<rt-evaluation-floating-panel
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragLockAxis="x"
  [cdkDragDisabled]="panelState.isFullScreen()"
  [cdkDragConstrainPosition]="constrainPosition"
  [rtFeatureTooltip]="tooltipConfig"
  [rtFeatureTooltipEnabled]="tooltipEnabled()"
  [data]="data()"
  [candidate]="candidate()"
  [availableOffers]="availableOffers()"
  [mentionUsers]="mentionUsers()"
  [restore]="restore()"
  (cdkDragEnded)="onDragEnded()"
  (close)="close.emit()"
/>
